<template>
  <div class="statistical-card bg-white pl-10 py-4 rounded-medium">
    <ul class="flex justify-between">
      <li class="item" v-for="(item, index) in list" :key="index">
        <p style="height: 22px" class="leading-22">
          <span class="text-medium opacity-65 mr-0.5">{{ item.label }}</span>
          <el-tooltip :content="typeof item.labelTip === 'function' ? item.labelTip(accountingRate) : item.labelTip" placement="top" effect="light">
            <i v-if="item.labelTip" class="iconfont icon-shuoming text-theme-black-350 text-medium cursor-pointer"></i>
          </el-tooltip>
        </p>
        <p style="height: 22px" class="mt-1 leading-22">
          <span class="font-semibold mr-1" :style="{ fontSize: (item.valueFontSize ? item.valueFontSize : '22') + 'px' }">{{
            item.value
          }}</span>
        </p>
        <span
          v-if="item.valueNote"
          :class="[
            `text-${item.valueNoteColor ? item.valueNoteColor : 'yellow-theme'}`,
            'text-small',
            'inline-block',
            item.clickabel ? 'cursor-pointer' : '',
            'mr-0.5'
          ]"
          @click="item.clickabel ? checkDetail() : ''"
          >{{ item.valueNote }}
          <el-tooltip :content="item.valueTip" placement="top" effect="light">
            <i v-if="item.valueTip" class="iconfont icon-shuoming text-theme-black-350 text-small cursor-pointer"></i>
          </el-tooltip>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    accountingRate(){
      return this.$store.getters.accountingRate
    }
  },
  methods: {
    checkDetail() {
      this.$emit('check-detail')
    }
  }
}
</script>

<style lang="scss" scoped>
.statistical-card {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.06);
  .item {
    border-right: 1px solid #d9dde0;
    padding-left: 4%;
    @apply flex-1;
    &:first-child {
      @apply pl-0;
    }
    &:last-child {
      @apply pr-0 border-r-0;
    }
  }
}
</style>
